export default {
    openMessage: 'openMessage',
    sendTyping: 'sendTyping',
    sendMessage: 'sendMessage',

    newMessage: 'newMessage',
    newUser: 'newUser',
    userLeft: 'userLeft',
    sendTypingReceiver: 'sendTyping'
}